import { useEffect, useState } from "react";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { FragmentDefault } from "./fragments/fragment-default";
import { FragmentAdd } from "./fragments/fragment-add";
import { usePurchaseInfosValueContextHook } from "../../../../contexts/PurchaseInfosContext";
import { FragmentLoad } from "./fragments/fragment-load";

const StyledPapaer = styled.div`
    background-color: var(--backgroundField);
`;
/**
 * 
 * @param {*} param0 
 * @param {param0.productOptionDetail} param0.productOptionDetail {productDto, productOptionDto}
 * @returns 
 */
export function ModalViewPurchaseMemo({
    open,
    productOptionDetail,
    onClose,
    ableToSelect = false,
    onSelect = () => { }
}) {
    const [viewType, setViewType] = useState('DEFAULT'); // DEFAULT, NEW
    const purchaseInfosValueContextHook = usePurchaseInfosValueContextHook();
    const purchaseInfos = purchaseInfosValueContextHook.purchaseInfos;
    
    const targetPurchaseInfos = purchaseInfos?.filter(purchaseInfo => purchaseInfo.productOptionId === productOptionDetail?.productOptionDto?.id);

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => {
                    onClose();
                }}
                maxWidth="md"
            >
                <StyledPapaer>
                    {!viewType && (
                        <>불러오는중</>
                    )}
                    {viewType === 'DEFAULT' && (
                        <FragmentDefault
                            onClose={onClose}
                            targetPurchaseInfos={targetPurchaseInfos}
                            productOptionDetail={productOptionDetail}
                            PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                            setViewType={setViewType}
                            ableToSelect={ableToSelect}
                            onSelect={onSelect}
                        />
                    )}
                    {viewType === 'ADD' && (
                        <FragmentAdd
                            onClose={onClose}
                            targetPurchaseInfos={targetPurchaseInfos}
                            productOptionDetail={productOptionDetail}
                            PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                            setViewType={setViewType}
                        />
                    )}

                    {viewType === 'LOAD' && (
                        <FragmentLoad
                            onClose={onClose}
                            setViewType={setViewType}
                            productOptionDetail={productOptionDetail}
                            PURCHASE_ROUTE_OPTIONS={PURCHASE_ROUTE_OPTIONS}
                        />
                    )}
                </StyledPapaer>
            </CustomDialog>
        </>
    );
}

const PURCHASE_ROUTE_OPTIONS = [
    {
        label: '전체',
        value: 'ALL',
        color: '#64748b' // neutral
    },
    {
        label: '1688',
        value: '1688',
        color: '#ff6a00' // 1688 brand-like orange
    },
    {
        label: '타오바오',
        value: 'TAOBAO',
        color: '#ff5000' // Taobao vivid orange
    },
    {
        label: 'ETC',
        value: 'ETC',
        color: '#3b82f6' // generic etc (blue)
    }
];